// src/components/media360/domain/fileTypes.js
// Helpers de tipos de fichero para Media360 (sin tocar backend)

export const VIDEO_EXTS = [".mp4", ".webm"];
export const IMAGE_EXTS = [".jpg", ".jpeg", ".png", ".webp"];
export const AUDIO_EXTS = [".mp3", ".ogg", ".wav", ".m4a", ".aac"];

export function getLowerExt(name = "") {
  const s = String(name).toLowerCase();
  const i = s.lastIndexOf(".");
  return i >= 0 ? s.slice(i) : "";
}

export function stripExt(name = "") {
  const s = String(name);
  const i = s.lastIndexOf(".");
  return i >= 0 ? s.slice(0, i) : s;
}

export function isVideoName(name = "") {
  const ext = getLowerExt(name);
  return VIDEO_EXTS.includes(ext);
}

export function isImageName(name = "") {
  const ext = getLowerExt(name);
  return IMAGE_EXTS.includes(ext);
}

export function isAudioName(name = "") {
  const ext = getLowerExt(name);
  return AUDIO_EXTS.includes(ext);
}

/**
 * Devuelve kind de alto nivel basándose en extensión.
 * @returns {"video"|"image"|"audio"|"unknown"}
 */
export function detectKindFromName(name = "") {
  if (isVideoName(name)) return "video";
  if (isImageName(name)) return "image";
  if (isAudioName(name)) return "audio";
  return "unknown";
}
